import React, {Suspense, useEffect,useState} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import { useDispatch, useSelector} from "react-redux";
import {LayoutSplashScreen, ContentRoute} from "../core/layout";
import { userFetch } from "../redux/actions";

import Routes from "./Routes";
import NotFound from "./views/NotFound";

import {DashboardPage} from "./pages/DashboardPage";

/*import {MyPage} from "./pages/MyPage";
const GoogleMaterialPage = lazy(() =>
  import("./modules/GoogleMaterialExamples/GoogleMaterialPage")
);
const ReactBootstrapPage = lazy(() =>
  import("./modules/ReactBootstrapExamples/ReactBootstrapPage")
);
const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);*/

const BasePage = (props) => {
    const { token, user} = useSelector(state => state.user);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(!!token);

    useEffect(() => {
        if (token) {
            dispatch(userFetch({ setLoading }));
        }
    }, [dispatch,token]);

    return (
        loading ? <LayoutSplashScreen/>:
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    <Redirect exact from="/" to="/dashboard"/>
                }
                <ContentRoute path="/dashboard" component={DashboardPage}/>
                {/*<ContentRoute path="/my-page" component={MyPage}/>*/}
                {/*<Route path="/google-material" component={GoogleMaterialPage}/>*/}
                {/*<Route path="/react-bootstrap" component={ReactBootstrapPage}/>*/}
                {/*<Route path="/e-commerce" component={ECommercePage}/>*/}

                {Routes[1].map((router, i) => (
                    <Route
                        key={i}
                        path={router.link}
                        render={props => (
                            <Suspense fallback={<LayoutSplashScreen/>}>
                                {user.role.name !== "customer" || router.customer ? (
                                    <router.component {...props} />
                                ) : (
                                    <NotFound />
                                )}
                            </Suspense>
                        )}
                        exact={true}
                    />
                ))}


                <Redirect to="error/error-v1"/>
            </Switch>
        </Suspense>
    );
};

export default BasePage;
